export const mindmap =
    {
        noMailMenu: true,
        rolesCanShowBannerInfo: ['learner', 'trainer']
    };